export default [ {
  path: '/cars',
  name: 'Cars',
  meta: {
    title: 'TabTitle.cars',
  },
  component: () => import('@/pages/cars.vue'),
} ];
